import React, { useState, useEffect } from "react";
import { FiTrash2, FiEdit } from "react-icons/fi";
import { TbLoader } from "react-icons/tb";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import ModalAddUser from "./ModalAddUser";
import { getUsers, deleteOneUser, getOneUser } from "../../../../helpers/Api"
import {useParams} from "react-router-dom";


const Usuarios = () => {

    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");
    const userPermission = localStorage.getItem("user_create_permission");
    const role = localStorage.getItem("role");
    const params = useParams();
    const idAgente = params.id || localStorage.getItem("agencia")
    const [users, setUsers] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [userData, setUserData] = useState([]);
    const [userName, setUserName] = useState('');

       //pagination
  const itemsPerPage = 10;
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);


  useEffect(() => {
    getAllUsers();
  }, [modalIsOpen, itemOffset, userName])
  
    
    const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    setUserData([]);
  };

  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  const getAllUsers = async () => {
    try {
        const response = await getUsers(
          token, 
          idAgente,
          itemsPerPage,
          itemOffset,
          userName,
          );
        if(response){
          response?.count === itemsPerPage
          ? setPageCount(1)
          : setPageCount(Math.ceil(response?.count / itemsPerPage));
          setUsers(response.results); 
        }
    } catch (error) {
        throw error
    } finally {
      setLoading(false);
    }
  };

  const handlerUserNameSearch = (e) => {
    setUserName(e.target.value);
  };


  const openModalToEdit = (value) =>{
    handlerGetOneUser(value);
    openModal();
   } 

  const handlerGetOneUser = async (userId) =>{
    try {
      const response = await getOneUser(userId, token)
      if(response){
        setUserData(response)
      }
    } catch (error) {
      throw error
    }
  }

  const handlerDeleteOneUser = async (idUser) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar este usuario",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteOneUser(idUser, token);
          if (!response) {
            Swal.fire("Exito", "El usuario ha sido borrada exitosamente ", "success");
            getAllUsers();
          }
        } catch (error) {
          Swal.fire(
            "Oops",
            "Ha surgido un problema al eliminar el usuario",
            "error"
          );
        }
      }
    });
  };

 
  return (
    <>
      <div className="row m-5">
      { loading ? (
          <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
              <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
          </div>
        ) : (
        <>
        <h6>Panel de Administración de usuarios</h6>
        <p>
          Usuarios autorizados para la gestión de información de agencias de
          aduana
        </p>
         <hr style={{ borderTop: "dotted 1px" }} />
        <div className="col-4">
            <input
              className="form-control"
              type="search"
              value={userName}
              onChange={handlerUserNameSearch}
              placeholder="Buscar por usuario"
              aria-label="Search"
              style={{ width: "100%" }}
            />
        </div>
        <hr style={{ borderTop: "dotted 1px", marginTop: "1rem" }} />
        <div className="row m-1">
          <div className="d-flex flex-row-reverse cta_solicitud">
          { (role === 'ASC' || userPermission === 'true') &&
          <button
              type="button"
              className="btn principal_button"
              onClick={openModal}
            >
              + Crear Usuario
            </button>
          }
          </div>
        </div>
        <ModalAddUser
        modalIsOpen={modalIsOpen} 
        closeModal={closeModal}
        token={token}
        userData={userData}
        />
        <div className="row mt-3">
          <div className="col-12 table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Nombre(s)</th>
                  <th scope="col">Apellidos</th>
                  <th scope="col">Usuario</th>
                  <th scope="col">Estatus</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              {users?.map((value, index) => (
              <tbody key={index}>
                <tr>
                  <td style={{ fontWeight: "600", color: "#059be6" }}>
                    {value.nombre}
                  </td>
                  <td style={{ fontWeight: "600", color: "#059be6" }}>
                  {value.apellidos}
                  </td>
                  <td>
                  {value.nombre_usuario}
                  </td>
                  <td>
                    {value.is_active ? 'activo' : 'pausado'}
                  </td>
                  <td>
                    <button className="btn" onClick={() => handlerDeleteOneUser(value.id)}>
                      <FiTrash2 style={{ color: "#F34949" }} />
                    </button>
                    <button className="btn" onClick={() => openModalToEdit(value.id)}>
                      <FiEdit />
                    </button>
                  </td>
                </tr>
              </tbody>
            ))}
            </table>
            <div className="row">
              <div className="col-12 d-flex justify-content-end paginationList">
              <ReactPaginate
              breakLabel="..."
              nextLabel="Siguiente"
              onPageChange={handlePageClick}
              pageRangeDisplayed={10}
              pageCount={pageCount}
              previousLabel="Anterior"
              renderOnZeroPageCount={null}
              containerClassName="pagination my-5 mx-auto"
              subContainerClassName="pages pagination"
              activeClassName="active"
              breakClassName="break-me"
              className="pagination"
            />
              </div>
            </div>
          </div>
        </div>
        </>)}
      </div>
    </>
  );
};

export default Usuarios;
